import edapWrapper from '@homeaway/edap-wrapper';

export const PRICE_SUMMARY_DISPLAY_EVENT = 'price.summary.display';

/**
 * Given a priceSummary returned by graphql-traveler-opas, triggers an EDAP
 * event asserting that the priceSummary has been displayed to the user.
 * @param {TravelerPricesSummary} priceSummary
 * @param edapOptions
 * @throws {Error} Throws if `priceSummary.edapEventJson` is missing or malformed
 */
export default function edapTriggerPriceSummaryDisplay(priceSummary, options) {
    let edapEvent;
    try {
        edapEvent = JSON.parse(priceSummary.edapEventJson);
    } catch (e) {
        throw new Error('Bad or missing edapEventJson for priceSummary');
    }
    edapWrapper().push({
        name: PRICE_SUMMARY_DISPLAY_EVENT,
        data: edapEvent,
        options
    });
}
